import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const HeroSlider = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
        pauseOnHover: false,
    };

    const slides = [
        {
            image: "mainPage.png",
            title: "KAHRAMAN AHŞAP MERDİVEN",
            subtitle: "Adımlarda Sanat, Merdivende Fark",
        },
        {
            image: "mainPage2.png",
            title: "KAHRAMAN AHŞAP MERDİVEN",
            subtitle: "SINCE 1976",
        },
    ];

    return (
        <div className="w-full h-[90vh] overflow-hidden relative">
            <Slider {...settings}>
                {slides.map((slide, index) => (
                    <div key={index} className="relative w-full h-[90vh]">
                        <img
                            src={"images/" + slide.image}
                            alt={slide.title}
                            className="w-full h-full object-cover"
                        />
                        {/* Metin Overlay */}
                        <div className="absolute inset-0 bg-black/30 flex flex-col justify-center items-center text-center text-white">
                            <h2 className="text-4xl md:text-6xl font-extrabold mb-4 drop-shadow-lg bg-stone-700/70 px-6 py-2 rounded-md">
                                {slide.title}
                            </h2>
                            <p className="text-lg md:text-2xl bg-stone-400/70 px-4 py-1 rounded-md font-bold">
                                {slide.subtitle}
                            </p>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default HeroSlider;
